<template> 
  <transition name="list">
    <div class="box-warning background-warning">
      <div class="position-relative" >
        <div class="row no-gutters justify-content-center">
          <div class="fixed-top d-block nav-bottom">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="bg-white hide-scroll overflow-scroll">
                    <div class="w-100">
                      <div class="mt-12">
                        <div class="p-3 background-warning">
                        	<div class="pop-up-warning bg-white text-center box-shadow-1 rounded">
	                        	<div class="pt-3 pb-2 px-1 border-bottom">
	                        		<p class="text-center body-1-1 px-4 text-black mb-0">{{title}}</p>
	                        	</div>
	                        	<div class="mt-3 pb-3 px-1 border-bottom">
                              <template v-if="show_image">
                               <img v-if="image == 'default'" :src="imgDefault" width="175">
		                        	 <img v-else :src="data.image" width="175">
                              </template>
		                        	<p class="text-center mb-0 body-2-1 text-black px-4 mt-3" v-html="body"></p>
	                        	</div>
	                          <div class="px-4 py-3 text-center">
                              <button class="btn body-2-1 text-white bg-green" v-if="btn != ''" @click="submitClick()">{{btn}}</button>
	                          </div>
	                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import imageNamaste from '@/assets/img/icon/namaste.png'

export default {
  props:{
    btn:{
      type: String,
      default: 'Close'
    },
    show_image:{
      type: Boolean,
      default: true
    },
    title:{
      type: String,
      default: 'Failed to add Product'
    },
    body:{
      type: String,
      default: 'Please make sure your status reservation is CHECKIN before adding some product to cart'
    },
    image:{
      type: String,
      default: 'default'
    }
  },
  data(){
    return{
      imgDefault: imageNamaste 
    }
  },
  methods:{
    submitClick(){
      this.$emit('close');
    }
  }
}
</script>
<style scoped>
  .box-warning{
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .background-warning{
    background-color: rgba(0,0,0,.5)!important;
  }
  .text-black{
    color:#000 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/popupWarningAddProduct.vue